<template>
    <module-card ref="moduleCard">
        <p>Select the correct word to replace the highlighted word and complete the sentence.</p>
        <div class="wrapper">
            <div class="beer-goggles-1">
                <p class="text-h6 text-center prompt-text" v-html="selectedPrompt.prompt"></p>
                <v-img class="mx-auto" :max-width="300" :src="selectedPrompt.img"></v-img>
                <div v-for="(answer, key) in selectedPrompt.answers" :key="key" :class="[isSelected(key) ? 'primary white--text' : 'grey lighten-3']" class="pa-3 mb-1" @click.stop="select(key)" v-ripple>
                    {{ answer.answer }}
                </div>
            </div>
            <div class="beer-goggles-2">
                <p class="text-h6 text-center prompt-text" v-html="selectedPrompt.prompt"></p>
                <v-img class="mx-auto" :max-width="300" :src="selectedPrompt.img"></v-img>
                <div v-for="(answer, key) in selectedPrompt.answers" :key="key" :class="[isSelected(key) ? 'primary white--text' : 'grey lighten-3']" class="pa-3 mb-1" @click.stop="select(key)" v-ripple>
                    {{ answer.answer }}
                </div>
            </div>
        </div>

        <template v-slot:actions>
            <v-spacer></v-spacer>
            <v-btn large color="primary" @click="backClick()" :disabled="backDisabled()">{{ backLabel }}</v-btn>
            <v-btn large color="primary" @click="nextClick()" :disabled="nextDisabled()">{{ nextLabel }}</v-btn>
            <v-spacer></v-spacer>
        </template>

        <ModalFeedback ref="modalFeedback"></ModalFeedback>
    </module-card>
</template>

<script>
    import { shuffle } from 'lodash';
    import { sync } from 'vuex-pathify';

    export default {
        props: {
            prompt: {
                type: Number,
                required: true
            },
            nextLabel: {
                type: String,
                default: 'Next'
            },
            backLabel: {
                type: String,
                default: 'Back'
            },
            backDisabled: {
                type: Function,
                default: () => false
            }
        },
        computed: {
            selectedPrompt() {
                return this.prompts[this.prompt - 1];
            },
            rubberMishapIncorrect: sync('rubberMishapIncorrect')
        },
        methods: {
            select(key) {
                this.selectedAnswer = key;
            },
            isSelected(key) {
                if (parseInt(key) === parseInt(this.selectedAnswer)) return true;
                else return false;
            },
            nextDisabled() {
                if (this.selectedAnswer === null) return true;
                else return false;
            },
            nextClick() {
                if (!this.selectedPrompt.answers[this.selectedAnswer].correct) {
                    this.rubberMishapIncorrect.push(this.selectedPrompt.id);

                    this.$refs.modalFeedback.show(false, shuffle(this.incorrectMessages)[0], () => {
                        this.$refs.moduleCard.nextClick();
                    });
                } else {
                    this.$refs.modalFeedback.show(true, 'You got it!', () => {
                        this.$refs.moduleCard.nextClick();
                    });
                }
            },
            backClick() {
                this.$refs.moduleCard.backClick();
            }
        },
        data() {
            return {
                selectedAnswer: null,
                incorrectMessages: ['Must be hard to focus!', 'Not quite!', 'Close!'],
                prompts: [
                    {
                        id: 1,
                        prompt: `Check the <span class="highlighted-word">exploration</span> date`,
                        img: require('@/assets/RubberMishap/01_exploration.png'),
                        answers: [
                            {
                                answer: `Exorcism`,
                                correct: false
                            },
                            {
                                answer: `Expiration`,
                                correct: true
                            },
                            {
                                answer: `Explanation`,
                                correct: false
                            },
                            {
                                answer: `Respiration`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 2,
                        prompt: `Check for <span class="highlighted-word">trolls</span> in condom package by applying light pressure.`,
                        img: require('@/assets/RubberMishap/02_troll.png'),
                        answers: [
                            {
                                answer: `Holes`,
                                correct: true
                            },
                            {
                                answer: `Rolls`,
                                correct: false
                            },
                            {
                                answer: `Bugs`,
                                correct: false
                            },
                            {
                                answer: `Prizes`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 3,
                        prompt: `Push condom to one side and then open package from other side to prevent <span class="highlighted-word">scaring</span> the condom. <span class="highlighted-word">Scare</span> with hands, not teeth.`,
                        img: require('@/assets/RubberMishap/03_scare.png'),
                        answers: [
                            {
                                answer: `Scarring/Scar`,
                                correct: false
                            },
                            {
                                answer: `Using/Use`,
                                correct: false
                            },
                            {
                                answer: `Tearing/Tear`,
                                correct: true
                            },
                            {
                                answer: `Losing/Lose`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 4,
                        prompt: `Make sure the <span class="highlighted-word">lip</span> of the condom points through the ring so it will roll down properly.`,
                        img: require('@/assets/RubberMishap/04_lip.png'),
                        answers: [
                            {
                                answer: `Tip`,
                                correct: true
                            },
                            {
                                answer: `Bottom`,
                                correct: false
                            },
                            {
                                answer: `Middle`,
                                correct: false
                            },
                            {
                                answer: `Side`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 5,
                        prompt: `Make sure the penis is <span class="highlighted-word">wrecked</span>. If the penis is “uncut,” pull back the foreskin. If penis is circumcised or “cut,” proceed to the next step.`,
                        img: require('@/assets/RubberMishap/05_wreck.png'),
                        answers: [
                            {
                                answer: `Soft`,
                                correct: false
                            },
                            {
                                answer: `Bedecked`,
                                correct: false
                            },
                            {
                                answer: `Correct`,
                                correct: false
                            },
                            {
                                answer: `Erect`,
                                correct: true
                            }
                        ]
                    },
                    {
                        id: 6,
                        prompt: `Place rolled condom on the <span class="highlighted-word">dead</span> of the penis. The tip of the condom should point up.`,
                        img: require('@/assets/RubberMishap/06_dead.png'),
                        answers: [
                            {
                                answer: `Scrotum`,
                                correct: false
                            },
                            {
                                answer: `Side`,
                                correct: false
                            },
                            {
                                answer: `Bottom`,
                                correct: false
                            },
                            {
                                answer: `Head`,
                                correct: true
                            }
                        ]
                    },
                    {
                        id: 7,
                        prompt: `Pinch the tip of the condom to let <span class="highlighted-word">hair</span> out and leave a half in space for a collection of semen.`,
                        img: require('@/assets/RubberMishap/07_hair.png'),
                        answers: [
                            {
                                answer: `Helium`,
                                correct: false
                            },
                            {
                                answer: `Air`,
                                correct: true
                            },
                            {
                                answer: `Dogs`,
                                correct: false
                            },
                            {
                                answer: `Balls`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 8,
                        prompt: `Roll condom down to the <span class="highlighted-word">face</span> of the penis.`,
                        img: require('@/assets/RubberMishap/08_face.png'),
                        answers: [
                            {
                                answer: `Top`,
                                correct: false
                            },
                            {
                                answer: `Back`,
                                correct: false
                            },
                            {
                                answer: `Base`,
                                correct: true
                            },
                            {
                                answer: `Middle`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 9,
                        prompt: `Apply <span class="highlighted-word">daughter</span>-based lube outside of the condom.`,
                        img: require('@/assets/RubberMishap/09_daughter.png'),
                        answers: [
                            {
                                answer: `Oil`,
                                correct: false
                            },
                            {
                                answer: `Third`,
                                correct: false
                            },
                            {
                                answer: `Water`,
                                correct: true
                            },
                            {
                                answer: `Latex`,
                                correct: false
                            }
                        ]
                    },
                    {
                        id: 10,
                        prompt: `After ejaculation or cumming, pull out when the penis is still hard, holding the condom at the base to prevent semen from <span class="highlighted-word">spitting</span>.`,
                        img: require('@/assets/RubberMishap/10_spit.png'),
                        answers: [
                            {
                                answer: `Impregnating`,
                                correct: false
                            },
                            {
                                answer: `Chilling`,
                                correct: false
                            },
                            {
                                answer: `Spending`,
                                correct: false
                            },
                            {
                                answer: `Spilling`,
                                correct: true
                            }
                        ]
                    },
                    {
                        id: 11,
                        prompt: `Tie the condom in a knot (so semen/cum doesn’t spill out) and throw it <span class="highlighted-word">okay</span>.`,
                        img: require('@/assets/RubberMishap/11_ok.png'),
                        answers: [
                            {
                                answer: `Away`,
                                correct: true
                            },
                            {
                                answer: `Astray`,
                                correct: false
                            },
                            {
                                answer: `Aloft`,
                                correct: false
                            },
                            {
                                answer: `At your partner`,
                                correct: false
                            }
                        ]
                    }
                ]
            };
        }
    };
</script>

<style scoped>
    .prompt-text /deep/ .highlighted-word {
        font-weight: bold;
        color: darkblue;
    }

    /* .highlighted-word {
    } */

    .wrapper {
        position: relative;
    }

    .beer-goggles-1 {
        position: relative;
    }

    .beer-goggles-2 {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: transparent;

        animation: doubleVision 15s infinite alternate;
    }

    .wrapper {
        animation: drunkCam 10s infinite alternate;
    }

    @keyframes drunkCam {
        0% {
            filter: blur(1px);
        }

        20% {
            filter: blur(2px);
        }

        24% {
            filter: blur(5px);
        }

        26% {
            filter: blur(2px);
        }

        28% {
            filter: blur(5px);
        }

        30% {
            filter: blur(1px);
        }

        60% {
            filter: blur(2px);
        }

        62% {
            filter: blur(6px);
        }

        65% {
            filter: blur(2px);
        }

        67% {
            filter: blur(1px);
        }

        80% {
            filter: blur(1px);
        }

        85% {
            filter: blur(2px);
        }

        88% {
            filter: blur(5px);
        }

        90% {
            filter: blur(0px);
        }
    }

    @keyframes doubleVision {
        0% {
            left: 0px;
            top: 0px;
            right: 0px;
            bottom: 0px;
            opacity: 0.5;
        }

        20% {
            left: 1px;
            top: 1px;
            right: -1px;
            bottom: -1px;
            opacity: 0.7;
        }

        24% {
            left: -5px;
            top: -5px;
            right: 5px;
            bottom: 5px;
            opacity: 0.7;
        }

        26% {
            left: 2px;
            top: 2px;
            right: -2px;
            bottom: -2px;
            opacity: 0.3;
        }

        28% {
            left: 5px;
            top: 5px;
            right: -5px;
            bottom: -5px;
            opacity: 0.7;
        }

        30% {
            left: -8px;
            top: -8px;
            right: 8px;
            bottom: 8px;
            opacity: 0.4;
        }

        60% {
            left: 2px;
            top: 2px;
            right: -2px;
            bottom: -2px;
            opacity: 0.8;
        }

        62% {
            left: 6px;
            top: 6px;
            right: -6px;
            bottom: -6px;
            opacity: 0.2;
        }

        65% {
            left: -2px;
            top: -2px;
            right: 2px;
            bottom: 2px;
            opacity: 0.8;
        }

        67% {
            left: 1px;
            top: 1px;
            right: -1px;
            bottom: -1px;
            opacity: 0.4;
        }

        80% {
            left: 1px;
            top: 1px;
            right: -1px;
            bottom: -1px;
            opacity: 0.9;
        }

        85% {
            left: 2px;
            top: 2px;
            right: -2px;
            bottom: -2px;
            opacity: 0.3;
        }

        88% {
            left: 5px;
            top: 5px;
            right: -5px;
            bottom: -5px;
            opacity: 0.5;
        }

        90% {
            left: 0px;
            top: 0px;
            right: 0px;
            bottom: 0px;
            opacity: 0.7;
        }
    }
</style>
